import { Grid } from "@mui/material"

import { TerminalCheatsheet } from "./TerminalCheatsheet"
import { ConnectionTest } from "./ConnectionTest"

export function AydenSummary() {
    return (
        <Grid container spacing="2rem" columns={{ xs: 8, md: 12 }}>
            <TerminalCheatsheet />
            <ConnectionTest />
        </Grid>
    )
}
